module.exports = __webpack_public_path__ + "static/media/trimex_harinamedalladeoro.60176695.png";